import { useState, useEffect } from "react";
import { getPaginatedDepartment } from "../services";
import { getSortParams } from "../utils/common-utils";
import { errorStatusHandle } from "../utils/error-utils";
import { useDispatch } from "react-redux";
import { getDepartmentPageSetting } from "../api/setting/pageApi";
import { setPageSettings } from "../store/actions/pageActions";
import { createGroupTree } from "../utils/group-tree";
import {
  clearComponentLoading,
  clearPageLoading,
  setComponentLoading,
  setPageLoading,
  clearButtonProcessing,
  setButtonProcessing
} from "../store/actions";
import _ from "lodash";

const useDepartmentUpdatePage = (reload, buttonId = '') => {
  const dispatch = useDispatch();
  const [departments, setDepartments] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10); //@todo
  const [numPages, setNumPages] = useState(1);
  const [count, setCount] = useState(0);
  const [filters, setFilters] = useState({
    group_1: null,
    group_2: null,
    group_3: null,
    group_4: null,
    group_5: null,
    position: null,
    user: null,
  });
  const [orderList, setOrderList] = useState({
    group_1: 0,
    group_2: 0,
    group_3: 0,
    group_4: 0,
    group_5: 0,
  });

  useEffect(() => {
    if (!_.isEmpty(buttonId)) {
      dispatch(setButtonProcessing(buttonId));
    }
    let sort = getSortParams(orderList);
    dispatch(setComponentLoading("department_update"));
    getPaginatedDepartment(page, perPage, filters, sort)
      .then((response) => {
        if (response.success) {
          let data = response.data.data;
          setDepartments(data);
          setCount(response.data.count);
          setNumPages(response.data.num_pages);
        }
        dispatch(clearComponentLoading("department_update"));
      })
      .catch((e) => {
        dispatch(clearComponentLoading("department_update"));
        errorStatusHandle(e);
      }).finally(() => {
      if (!_.isEmpty(buttonId)) {
        dispatch(clearButtonProcessing(buttonId));
      }
    });
  }, [orderList, filters, page, perPage, reload]);

  return {
    departments,
    page,
    perPage,
    numPages,
    count,
    filters,
    orderList,
    setDepartments,
    setPage,
    setPerPage,
    setNumPages,
    setCount,
    setFilters,
    setOrderList,
  };
};

export const useDepartmentUpdatePageSetting = (setFilters) => {
  const [users, setUsers] = useState([]);
  const [positions, setPositions] = useState([]);
  const [groupsList, setGroupsList] = useState({});
  const [groupsChildren, setGroupsChildren] = useState({});
  const [groupTree, setGroupTree] = useState(null);
  const [filterList, setFilterList] = useState({
    1: { value: null, label: "[ALL]" },
    2: { value: null, label: "[ALL]" },
    3: { value: null, label: "[ALL]" },
    4: { value: null, label: "[ALL]" },
    5: { value: null, label: "[ALL]" },
    position: { value: null, label: "[ALL]" },
    user: { value: null, label: "[ALL]" },
  });
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageLoading());
    getDepartmentPageSetting({ page: "update" })
      .then((pageSettings) => {
        dispatch(setPageSettings(pageSettings));
        if (pageSettings.user_setting?.setting) {
          const filterListSetting = pageSettings.user_setting.setting;
          setFilterList(filterListSetting);
          setFilters({
            group_1: filterListSetting[1]?.value,
            group_2: filterListSetting[2]?.value,
            group_3: filterListSetting[3]?.value,
            group_4: filterListSetting[4]?.value,
            group_5: filterListSetting[5]?.value,
            position: filterListSetting["position"]?.value,
            user: filterListSetting["user"]?.value,
          });
        }
        let user = [{ value: null, label: "[ALL]" }];
        // get all users for select
        pageSettings.options.users.forEach((u, i) => {
          const temp = {
            value: u.id,
            label: `${u.name}(${u.username})`,
            email: u.email,
          };
          user = [...user, temp];
        });
        setUsers(user);
        let pos = [{ value: null, label: "[ALL]" }];
        // get all users for select
        pageSettings.options.positions.forEach((p, i) => {
          const temp = {
            value: p.id,
            label: p.name,
          };
          pos = [...pos, temp];
        });
        setPositions(pos);
        setGroupsChildren(pageSettings.options.group_and_children);
        let grouplst = {
          1: [],
          2: [],
          3: [],
          4: [],
          5: [],
        };
        Object.entries(pageSettings.options.group_list).forEach((group) => {
          grouplst[group[0]] = group[1].map((v) => {
            return { value: v.id, label: v.name };
          });
        });
        setGroupsList(grouplst);
        const root = createGroupTree(
          pageSettings.options.group_list,
          pageSettings.options.group_and_children
        );
        setGroupTree(root);
        dispatch(clearPageLoading());
      })
      .catch((e) => {
        dispatch(clearPageLoading());
        errorStatusHandle(e.response);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    users,
    setUsers,
    groupsList,
    setGroupsList,
    groupsChildren,
    setGroupsChildren,
    groupTree,
    setGroupTree,
    positions,
    setPositions,
    filterList,
    setFilterList
  };
};

export default useDepartmentUpdatePage;
